import { render, staticRenderFns } from "./VisitCustomer.vue?vue&type=template&id=2e978d0c&"
import script from "./VisitCustomer.vue?vue&type=script&lang=js&"
export * from "./VisitCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports